import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';
import { FormInputMaskModule } from '@feature/forms/form-input-mask/form-input-mask.module';

import { FormInputComponent } from './form-input.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PercentageDirective } from './percentage.directive';
// Temporarily commented out for Angular 18 upgrade - needs alternative
// import {
//   MAT_COLOR_FORMATS,
//   NGX_MAT_COLOR_FORMATS,
//   NgxMatColorPickerModule,
// } from '@angular-material-components/color-picker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
export const imports: NgModule['imports'] = [
  FormErrorModule,
  FormInputMaskModule,
  MatAutocompleteModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatNativeDateModule,
  MatRadioModule,
  MatSelectModule,
  MatSliderModule,
  ReactiveFormsModule,
  MatTooltipModule,
  // NgxMatColorPickerModule, // Temporarily commented out for Angular 18 upgrade
  MatButtonModule,
];

@NgModule({
  declarations: [FormInputComponent, PercentageDirective],
  imports: [...imports, AppTranslateModule, CommonModule],
  exports: [FormInputComponent],
  providers: [
    // { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS } // Temporarily commented out for Angular 18 upgrade
  ],
})
export class FormInputModule {}
